import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "unFullScreen",
  "use": "unFullScreen-usage",
  "viewBox": "0 0 58.08 58.08",
  "content": "<symbol viewBox=\"0 0 58.08 58.08\" id=\"unFullScreen\"><title>资源 4</title><g id=\"unFullScreen_图层_2\" data-name=\"图层 2\"><g id=\"unFullScreen_图层_1-2\" data-name=\"图层 1\"><path d=\"M50.82,0H7.26A7.55,7.55,0,0,0,0,7.56v43.3a7.21,7.21,0,0,0,7.21,7.22H50.87a7.21,7.21,0,0,0,7.21-7.22V7.56A7.55,7.55,0,0,0,50.82,0Zm3.65,21.78h0v29a4,4,0,0,1-4,3.65H7.59a4,4,0,0,1-4-3.65v-29h0V7.56A3.94,3.94,0,0,1,7.26,3.63H50.82a3.94,3.94,0,0,1,3.65,3.93Z\" /><path d=\"M24.78,31.47H8.9A1.77,1.77,0,0,0,8.9,35H20.63l-12,12h0l0,0h0a1.77,1.77,0,0,0,2.49,2.49h0l12-12-.06,11.64a1.77,1.77,0,1,0,3.54,0V33.24A1.59,1.59,0,0,0,26,32a1.76,1.76,0,0,0-1.26-.53Z\" /><path d=\"M49.18,23.06H37.44l12-12h0l.06-.05A1.77,1.77,0,0,0,47,8.47L47,8.53h0l-12,12L35,8.9a1.77,1.77,0,0,0-3.54,0V24.83A1.59,1.59,0,0,0,32,26.07a1.77,1.77,0,0,0,1.26.53H49.18a1.77,1.77,0,1,0,0-3.54Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/unFullScreen.svg
// module id = IlIn
// module chunks = 264